import React from 'react';
import { Avatar, Flex, theme } from 'antd';


function AnnotationBubble() {
    const {
        token: {
            colorBgContainer,
            borderRadiusLG,
            colorPrimary,
            colorPrimaryBorder,
            colorTextDescription,
            colorBorder,
            fontSizeSM,
            colorError,
            colorBgElevated,
            colorBorderSecondary,
            colorTextSecondary,
            colorWarning,
        },
    } = theme.useToken();
    return (
        <Flex align='flex-start' gap={16}>
            <Avatar
                src="https://randomuser.me/api/portraits/women/44.jpg" // Replace with your image
                alt="User"
                size={40}
            />
            <Flex vertical gap={4} style={{ width: '100%' }}>
                <Flex justify='space-between' align='center'>
                    <span>John Doe</span>
                <span style={{fontSize:12}}>2022 Jan 12 | 10.15 AM</span>
                </Flex>
                <div style={{
                    backgroundColor: '#4CC417', // green bubble
                    color: 'white',
                    borderRadius: '12px',
                    padding: '8px 12px',
                    // maxWidth: '300px',
                    width: '100%',
                    lineHeight: '20px',
                    fontWeight: 400,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    Please Check These Number<br />Again . . . !
                </div>
            </Flex>
        </Flex>
    );
}

export default AnnotationBubble;
